// Import model
import { WasteFactor } from '../models/WasteFactor';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for WasteFactor - handles JSON serialization and deserialization with type validation
 */
export class WasteFactorSerializer {
  /**
   * Deserializes a JSON string into a WasteFactor instance
   */
  static deserialize(json: string): WasteFactor {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a WasteFactor instance
   */
  static fromObject(obj: any): WasteFactor {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to WasteFactor');
    }


    const instance: WasteFactor = {
      productType: obj['productType'] as string | undefined,
      productTypeName: obj['productType|Name'] as string | undefined,
      patternTypeId: obj['patternTypeId'] as string | undefined,
      patternTypeIdName: obj['patternTypeId|Name'] as string | undefined,
      catalogFeedId: obj['catalogFeedId'] as string | undefined,
      catalogFeedIdName: obj['catalogFeedId|Name'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      itemIdName: obj['itemId|Name'] as string | undefined,
      styleNumber: obj['styleNumber'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      createdByUserId: obj['createdByUserId'] as string | undefined,
      createdByUserIdName: obj['createdByUserId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of WasteFactor instances
   */
  static deserializeArray(json: string): WasteFactor[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a WasteFactor instance to a JSON string
   */
  static serialize(instance: WasteFactor): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a WasteFactor instance to a plain object
   */
  static toObject(instance: WasteFactor): any {
    return {
      'productType': instance.productType,
      'productType|Name': instance.productTypeName,
      'patternTypeId': instance.patternTypeId,
      'patternTypeId|Name': instance.patternTypeIdName,
      'catalogFeedId': instance.catalogFeedId,
      'catalogFeedId|Name': instance.catalogFeedIdName,
      'itemId': instance.itemId,
      'itemId|Name': instance.itemIdName,
      'styleNumber': instance.styleNumber,
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'createdByUserId': instance.createdByUserId,
      'createdByUserId|Name': instance.createdByUserIdName,
    };
  }

  /**
   * Serializes an array of WasteFactor instances to a JSON string
   */
  static serializeArray(instances: WasteFactor[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
